// Module
var code = `<style>:host{display:flex;text-align:right;align-items:center;min-width:48px;min-height:12px}</style> <div id="val"></div>`;
// Exports
export default code;